import { useRecoilValue } from "recoil";
import { FormStatusBase } from "../../../../components";
import { addSmartcardState } from "../atoms/atoms";

// const FormStatus: React.FC = () => {
export default function FormStatus() {
  const state = useRecoilValue(addSmartcardState);
  return <FormStatusBase state={state} />;
}

// export default FormStatus;
